import React, { Component } from 'react';
import Drug from './drug';

export default class DrugAdministration extends Component {
  render() {
    return <Drug></Drug>;
  }
}
